import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "vi-rating-bar" }

import { computed } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'vi-rating-bar',
  props: {
    value: {},
    size: {},
    type: {},
    negative: {},
    positive: {}
  },
  setup(__props: any) {

const props = __props;

const stylesLeft = computed(() => {
  const style: Record<string, any> = {};

  if (props.size === "large") {
    style["height"] = "24px";
  }

  if (props.type !== "double") {
    if (props.value < 0) {
      style["background"] =
        `linear-gradient(270deg, #e66e79 0%, #e66e79 ${Math.abs(props.value)}%, rgba(0, 0, 0, 0) ${Math.abs(props.value)}%)`;
    }
  }

  if (props.type === "double") {
    style["background"] =
      `linear-gradient(270deg, #e66e79 0%, #e66e79 ${Math.abs(props.negative)}%, rgba(0, 0, 0, 0) ${Math.abs(props.negative)}%)`;
  }
  return style;
});

const stylesRight = computed(() => {
  const style: Record<string, any> = {};

  if (props.size === "large") {
    style["height"] = "24px";
  }

  if (props.type !== "double") {
    if (props.value > 0) {
      style["background"] =
        `linear-gradient(90deg, #2cbfaf 0%, #2cbfaf ${props.value}%, rgba(0, 0, 0, 0) ${props.value}%)`;
    }
  }
  if (props.type === "double") {
    style["background"] =
      `linear-gradient(90deg, #2cbfaf 0%, #2cbfaf ${props.positive}%, rgba(0, 0, 0, 0) ${props.positive}%)`;
  }
  return style;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      style: _normalizeStyle(stylesLeft.value),
      class: "vi-rating-bar__left"
    }, null, 4),
    _createElementVNode("div", {
      style: _normalizeStyle(stylesRight.value),
      class: "vi-rating-bar__right"
    }, null, 4)
  ]))
}
}

})